import { PlanDataType } from ".";

export const PlanData: PlanDataType[] = [
  {
    id: 1,
    text: "Reduce or eliminate symptoms of respiratory distress.",
    category: "goals"
  },
  {
    id: 2,
    text: "Fewer exacerbations and flares.",
    category: "goals"
  },
  {
    id: 3,
    text: "Avoid triggers that precipitate symptoms.",
    category: "goals"
  },
  {
    id: 4,
    text: "Decrease the need of fast-acting medications.",
    category: "goals"
  },
  {
    id: 5,
    text: "Minimize medication adverse effects.",
    category: "goals"
  },
  {
    id: 6,
    text: "Adhere to take medications, including" +
      " inhalers and nebulizers as prescribed.",
    category: "intervention"
  },
  {
    id: 7,
    text: "Avoid heat and humidity as much as possible.",
    category: "intervention"
  },
  {
    id: 8,
    text: "Smoking Cessation.",
    category: "intervention"
  },
  {
    id: 9,
    text: "Manage stress and excercise as tolarated.",
    category: "intervention"
  },
  {
    id: 10,
    text: "Monitor for symptoms of chest pain, wheezing" +
      " with exertion, at rest or when lying down cough.",
    category: "intervention"
  },
  {
    id: 11,
    text: "Check pulse oximeter at home as directed, alert" +
      " provider if any changes in normal readings.",
    category: "intervention"
  }
]